import React from "react";
import { Button, ButtonVariant, Card, Text } from "@merge-api/merge-javascript-shared";
import { LinkedAccount, UnreleasedAPICategory } from "../../../../models/Entities";

type Props = {
  linkedAccount: LinkedAccount;
  onClick: () => void;
};

const LinkedAccountDeleteSwitch = ({ linkedAccount, onClick }: Props) => {
  const deleteText =
    linkedAccount.category === UnreleasedAPICategory.datawarehouse
      ? "Synced data models cannot be deleted because Merge does not have DELETE permissions on destinations. "
      : "After deleting this Linked Account, you’ll be notified once deletion of all associated data - including synced data models - is complete.";

  return (
    <Card className="p-5 flex flex-col gap-y-3">
      <Text variant="h4">Delete Linked Account</Text>

      <Text>{deleteText}</Text>
      <Text>Deletion is irreversible!</Text>

      <Button variant={ButtonVariant.DangerFilled} onClick={onClick} className="mt-3">
        Delete Linked Account
      </Button>
    </Card>
  );
};

export default LinkedAccountDeleteSwitch;
